// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610261004/js/" + chunkId + "." + {"44":"5db7b35b","225":"d497d0a9","481":"18215b92","486":"f67266f7","770":"d966cf25"}[chunkId] + ".0.2672725777494762.chunk.js";
};